import { zodResolver } from '@hookform/resolvers/zod';
import { type SivVehicle, sivControllerSearchSiv } from 'korint-sdk';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { Form, FormControl, FormField, FormItem, FormMessage } from '../../forms/form';
import { Input } from '../../forms/input';
import { Button } from '../../ui/button';
import { Spinner } from '../../ui/spinner';

const vehicleInputSchema = z.object({
  registrationNumber: z
    .string()
    .min(
      7,
      "Le numéro d'immatriculation est trop court. Il doit contenir au minimum 7 caractères.",
    ),
});

export const VehicleInput = ({
  onChange,
  onError,
  defaultRegistrationNumber,
}: {
  onError?: (error: unknown) => void;
  onChange?: (vehicle: SivVehicle) => void;
  defaultRegistrationNumber?: string;
}) => {
  const form = useForm<{ registrationNumber: string }>({
    defaultValues: {
      registrationNumber: defaultRegistrationNumber ?? '',
    },
    resolver: zodResolver(vehicleInputSchema),
  });

  const onSubmit = async ({ registrationNumber }: { registrationNumber: string }) => {
    try {
      const vehicle = await sivControllerSearchSiv({
        registrationNumber: registrationNumber,
      });
      onChange?.(vehicle);
    } catch (error) {
      onError?.(error);
    }
  };

  return (
    <Form {...form}>
      <form className="flex gap-3" onSubmit={form.handleSubmit(onSubmit)}>
        <FormField
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <Input {...field} placeholder="Numéro d'immatriculation" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
          name="registrationNumber"
        />

        <Button type="submit" disabled={form.formState.isSubmitting} className="gap-2">
          {form.formState.isSubmitting && <Spinner className="h-5 w-5 text-white" />}
          Rechercher
        </Button>
      </form>
    </Form>
  );
};
